export default __webpack_public_path__ + "ef9e8e69be99af32440593426fe9f1c1.png";